import { SET_MODE } from './../constants/actionTypes'

const isShore = (store = false, action = {}) => {
  switch (action.type) {
    case SET_MODE:
      return action.data
    default:
      return store
  }
}

export default isShore
